import { useQuery } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { UnknownTransaction } from "src/pages/Admin/UnkownTransactions/Type";

import { apiClient } from "../../config/apiClient";
import { API } from "../../config/apiConfig";

async function getUnknownTransactionsRequest() {
	return await apiClient.get(API.QUERY.ADMIN.UNKOWN_TRANSACTIONS).then((res) => res.data);
}

export function useGetUnknownTransactions() {
	return useQuery<UnknownTransaction[], AxiosError>({
		queryKey: ["adminUnknownTransactions"],
		queryFn: getUnknownTransactionsRequest,
		refetchOnWindowFocus: true
	});
}
